import { Bq1GeneralInformation } from "../../baltic-form/pages/Bq1GeneralInformation";
import { Bq2Certification } from "../../baltic-form/pages/Bq2Certification";
import { Bq3CrewManagement } from "../../baltic-form/pages/Bq3CrewManagement";
import { Bq4SafetyManagement } from "../../baltic-form/pages/Bq4SafetyManagement";
import { Bq5CargoArrangements } from "../../baltic-form/pages/Bq5CargoArrangements";
import { Bq6CargoGear } from "../../baltic-form/pages/Bq6CargoGear";
import { Bq7Container } from "../../baltic-form/pages/Bq7Container";
import { Bq8Mooring } from "../../baltic-form/pages/Bq8Mooring";
import { Bq9EngineRoom } from "../../baltic-form/pages/Bq9EngineRoom";
import { Bq10Miscellaneous } from "../../baltic-form/pages/Bq10Miscellaneous";
import PageFooter from "../../shared/app-shell/PageFooter";
import { themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import DownloadBQButton from "../components/DownloadBqButton";
import { Tabs, Tab } from "../components/VesselTabs";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

const BalticQuestionnaireTab = () => {
  const theme = useAtomValue(themeAtom);

  const [isLoading, setIsLoading] = useState(false);
  const isCompletedForm = true;

  const cacheInitialForm = (form: any) => {
    console.log(form);
  };

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <div className="flex flex-col gap-2">
        <main
          className={twMerge(
            "flex flex-1 flex-col overflow-y-auto",

            "overflow-x-auto",
            "[&::-webkit-scrollbar]:h-1.5",
            "[&::-webkit-scrollbar-track]:bg-transparent",
            "[&::-webkit-scrollbar-thumb]:rounded-full",
            theme.uwhcAssistant.tableScroll,
            theme.uwhcAssistant.scrolHover,
          )}
        >
          <div className="relative flex flex-row">
            <div className="flex h-[calc(100vh-265px)] flex-col">
              <Tabs>
                <Tab label="General info">
                  <Bq1GeneralInformation
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Certification">
                  <Bq2Certification
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Crew">
                  <Bq3CrewManagement
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Safety">
                  <Bq4SafetyManagement
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Cargo">
                  <Bq5CargoArrangements
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Cargo Gear">
                  <Bq6CargoGear isCompletedForm={isCompletedForm} cacheInitialForm={cacheInitialForm} readonly={true} />
                </Tab>
                <Tab label="Container">
                  <Bq7Container isCompletedForm={isCompletedForm} cacheInitialForm={cacheInitialForm} readonly={true} />
                </Tab>
                <Tab label="Mooring">
                  <Bq8Mooring isCompletedForm={isCompletedForm} cacheInitialForm={cacheInitialForm} readonly={true} />
                </Tab>
                <Tab label="Engine">
                  <Bq9EngineRoom
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
                <Tab label="Misc">
                  <Bq10Miscellaneous
                    isCompletedForm={isCompletedForm}
                    cacheInitialForm={cacheInitialForm}
                    readonly={true}
                  />
                </Tab>
              </Tabs>
            </div>
            <div className="absolute right-10 top-0">
              <DownloadBQButton loadingToggle={setIsLoading} />
            </div>
          </div>
        </main>
        <PageFooter />
      </div>
    </LoadingWrapper>
  );
};

export default BalticQuestionnaireTab;
